const _ = require("lodash")
const noop = () => undefined
import ACTION_TYPES from "./datatables/action_types.mjs"
import renderActions from "./datatables/actions.mjs"

function createAcaoConsultar(acao, url, tipo) {
    return createAcao(
        acao,
        url,
        'btnConsultar',
        'Consultar',
        'Consultar',
        tipo,
        'find_in_page',
        true,
    );
}

function createAcaoAlterar(acao, url, tipo) {
    return createAcao(
        acao,
        url,
        'btnAlterar',
        'Alterar',
        'Alterar',
        tipo,
        'edit',
        true,
    );
}

function createAcaoDesativar(acao, url, tipo) {
    return createAcao(
        acao,
        url,
        'btnDesativar',
        'Desativar',
        'Desativar',
        tipo,
        'delete',
        true,
    );
}

function createAcao(
    acao,
    url,
    strClass,
    strLabel,
    strTitle,
    strTipo,
    strIcon,
    isMD) {
    strTipo = strTipo === undefined ? ACTION_TYPES.NORMAL : strTipo;
    strIcon = strIcon === undefined ? 'error' : strIcon;
    isMD = isMD === undefined ? true : isMD;

    return {
        url: url,
        acao: acao,
        data: [],
        class: strClass,
        label: strLabel,
        tipo: strTipo,
        title: strTitle,
        name: strClass,
        id: strClass,
        icon: strIcon,
        MD: isMD,
        width: 1200,
        height: 700,
    };
}

/**
 * Hoje o DataTables tem dois modos de operação bem distintos: server ou client.
 * Esta função foi criada provisoriamente para prover um comportamento híbrido: permitir controles do cliente usando dados do server.
 * Ainda em desenvolvimento.
 * @param opts
 * @returns {Api<any>}
 */
function buildClientSideWithServerData(opts) {
    const tableId = opts.tableId
    const tableEl = $('#' + tableId)
    const {initComplete, ...dtAttributes} = opts.otherDTAttributes || {}
    const userOnInitComplete = initComplete || noop
    let columns = opts.columns ? opts.columns : [];
    const searched = true;
    const deferLoading = dtAttributes.deferLoading ?? false;

    const dt = tableEl.DataTable({
        columns: columns,
        processing: true,
        serverSide: false,
        // responsive: getResponsive(opts.isResponsivoComDetalhe),
        buttons: {buttons: opts.buttons, dom: $.fn.dataTable.defaults.buttons.dom},
        paging: false,
        drawCallback: (settings) => {
            updateTitleCountBadge(tableId, searched, dtAttributes.deferLoading, settings)
            return opts.drawCallbacks.forEach(fn => fn(settings))
        },
        initComplete: function(settings, json) {
            onInitCompleteAddRowCount(tableId, opts, settings, json)
            updateTitleCountBadge(tableId, searched, dtAttributes.deferLoading, settings)
            userOnInitComplete(settings, json)
        },
    });
    return dt
}

function build(opts) {
    const initOpts = opts;
    const idFormParams = opts.ajaxData.idFormParams
    const tableId = opts.tableId
    const tableEl = $('#' + tableId)
    const onSelectCallback = opts.onSelectCallback || noop
    const {initComplete, ...dtAttributes} = opts.otherDTAttributes || {}
    const userOnInitComplete = initComplete || noop
    const allColumns = opts.allColumns || [];
    const isResponsivoComDetalhe = opts.isResponsivoComDetalhe;
    const buttons = opts.buttons;
    const drawCallbacks = opts.drawCallbacks;
    const url = tableEl.data('url');
    const deferLoading = dtAttributes.deferLoading ?? false;
    const keepInCookie = opts.keepInCookie ?? false
    const keepInCookieName = opts.keepInCookieName ?? ''
    const nameSelecionavel = opts.nameSelecionavel ?? 'chkRow'
    const allowToggleColumns = opts.allowToggleColumns ?? false;
    const reloadOnToggleColumns = opts.reloadOnToggleColumns ?? false;

    let searched = !deferLoading;

    var ajax = {
        "url": url,
        "type": "POST",
        "data": function(data) {
            if (opts.ajaxData.acoes) {
                data['dt_acoes'] = opts.ajaxData.acoes;
            }

            if (opts.ajaxData.paramsComuns) {
                data['dt_paramsComunsAcoes'] = opts.ajaxData.paramsComuns;
            }

            if (opts.ajaxData.customColumns) {
                data['dt_customColumns'] = opts.ajaxData.customColumns;
            }

            $.fn.dataTable.montarData(data, $(`#${idFormParams}`));
        },
        "error": function(jqXHR, textStatus, errorThrown) {
            function extrairMensagens(xhr, plural, singular) {
                let xmlMesagens = $($.parseXML(xhr)).find(plural);
                let arrMensagens = [];
                xmlMesagens.each(function() {
                    arrMensagens.push($(this).find(singular).attr('descricao').infraReplaceAll('\\n', '<br>'));
                });
                return arrMensagens;
            }

            const arrErros = extrairMensagens(jqXHR.responseText, 'erros', 'erro');
            const arrWarnings = extrairMensagens(jqXHR.responseText, 'warnings', 'warning');

            $(`#${tableId}_processing`).hide();
            if (arrErros.length > 0) {
                eproc.toast.error({
                    text: arrErros.join('<br>'),
                    data: {delay: 5000},
                });
            }
            if (arrWarnings.length > 0) {
                eproc.toast.warning({
                    text: arrWarnings.join('<br>'),
                    data: {delay: 5000},
                });
            }
        },
    }

    let columns = opts.columns ? opts.columns : [];
    let defaultOrderableColumn = 0;

    if (opts.isSelecionavel) {
        defaultOrderableColumn++;
        columns = configColunaSelecionavel(columns, opts.nameSelecionavel);
    }
    if (opts.isResponsivoComDetalhe) {
        defaultOrderableColumn++;
        columns = configColunaExpandirDetalhes(columns);
    }
    if (opts.colunaAcoes) {
        columns = configColunaAcoes(columns, opts.isResponsivoComDetalhe);
    }

    let dt = tableEl.DataTable(_.merge({
        ajax: ajax,
        columns: columns,
        processing: true,
        serverSide: true,
        order: [[defaultOrderableColumn, 'asc']],
        responsive: getResponsive(isResponsivoComDetalhe),
        buttons: {buttons: buttons, dom: $.fn.dataTable.defaults.buttons.dom},
        paging: false,
        drawCallback: (settings) => {
            updateTitleCountBadge(tableId, searched, deferLoading, settings)
            return drawCallbacks.forEach(fn => fn(settings))
        },
        initComplete: function(settings, json) {
            if (allColumns.length > 0) {
                inicializarColunasVisiveis();
            }
            addListeners(tableId, settings)
            onInitCompleteAddRowCount(tableId, opts, settings, json)
            updateTitleCountBadge(tableId, searched, deferLoading, settings)
            userOnInitComplete(settings, json)
        },
    }, dtAttributes));

    function addListeners(tableId, settings) {
        const el = $(`#${tableId}`);
        const dt = el.DataTable()

        dt.on('draw', () => {
            const chkData = getCheckedData(opts.tableId)
            toggleAcoes(chkData);
        });

        if (deferLoading) {
            $('#' + tableId + ' .dataTables_empty').html(settings['oLanguage']['sNotInitializedEmptyTable']);
            $('#' + tableId + '_wrapper .dataTables_info').html(settings['oLanguage']['sNotInitializedInfoEmpty']);
            $('#' + tableId + '_length').hide();
            $('#' + tableId + '_wrapper .dataTables_paginate').hide()

            dt.on('preXhr', (e, settings, data) => {
                searched = true;
                initOpts.deferLoading = false; // caso a config seja reutilizada para recriar o dataTable, seu deferLoading já será false
                $('#' + tableId + '_length').show()
                $('#' + tableId + '_wrapper .dataTables_paginate').show()
            });
        }

        $('body').on('click', `#${opts.tableId} input[name="chkTodos"]`, function() {
            const table = $(this).closest('table')
            table.find('input[name^="' + nameSelecionavel + '"]').prop('checked', this.checked)
            var chkData = getCheckedData(opts.tableId)
            onSelectCallback(chkData);
            toggleAcoes(chkData);
        });

        tableEl.on('change', '[class="chkRowDataTable"]', function() {
            var chkData = getCheckedData(opts.tableId);
            onSelectCallback(chkData);
            toggleAcoes(chkData);
        });
    }

    function inicializarColunasVisiveis() {
        $('#selColunasVisiveis .dropdown-menu').on('click', (event) => {
            event.stopImmediatePropagation();

            const target = event.target

            if (searched || allowToggleColumns) {
                toggleColunaVisiveis(target);
            }

            if (keepInCookie) {
                const columnName = $(target).data('value')
                const span = $(target).find('span')
                if (span) {
                    const isMarked = infraTrim(span.html()) === 'done'
                    keepCollumnInCookie(columnName, isMarked)
                }
            }
        });

        if (keepInCookie) {
            initKeepInCookie()
        }

        addListenerOnChangeColunasVisiveis();
    }

    function toggleColunaVisiveis(coluna) {
        const hdnSelColunasVisiveis = $('#hdnSelColunasVisiveis');
        const value = hdnSelColunasVisiveis.val().split(',')

        let [newValue, pattern, replacement] = ['', '', '']
        let nomeCampoSelecionado = getNomeCampoSelecionado(coluna);
        if (coluna.innerHTML.includes('done')) { // Desmarca
            newValue = value.filter((v) => v !== nomeCampoSelecionado).join(',');
            [pattern, replacement] = ['done', '&nbsp;'];
        } else { // Marca
            newValue = value + ',' + nomeCampoSelecionado;
            [pattern, replacement] = ['&nbsp;', 'done'];
        }

        hdnSelColunasVisiveis.val(newValue);
        coluna.innerHTML = coluna.innerHTML.replace(pattern, replacement);
    }

    /**
     * Função necessária para retornar corretamente o nome do campo clicado.
     * Ela é útil, pois existem momentos que o usuário clica no elemento 'span' e em outros na âncora 'a';
     * @param coluna
     */
    function getNomeCampoSelecionado(coluna) {
        //se o valor vier preenchido - o clique veio da tag âncora 'a'
        let nomeCampoSelecionado = coluna.getAttribute('data-value');

        if (nomeCampoSelecionado == null) {
            //clique proveniente da tag span
            nomeCampoSelecionado = $(coluna).closest('a').attr('data-value')
        }
        return nomeCampoSelecionado;
    }

    function addListenerOnChangeColunasVisiveis() {
        const dropdown = document.querySelector('#selColunasVisiveis');
        let valoresIniciais = $('#hdnSelColunasVisiveis').val();

        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                const valoresAtuais = $('#hdnSelColunasVisiveis').val();
                if (
                    mutation.type === "attributes" &&
                    !dropdown.classList.contains('show') &&
                    valoresIniciais !== valoresAtuais
                ) {
                    valoresIniciais = valoresAtuais;
                    updateColumns(valoresIniciais.split(','));

                    if (searched && reloadOnToggleColumns) {
                        $(`#${tableId}`).dataTable().api().formSearch();
                    }
                }
            });
        });

        observer.observe(dropdown, {
            attributes: true,
        });
    }

    function keepCollumnInCookie(columnName, isMarked) {
        if (infraCookiesHabilitados()) {
            const cookieName = tableId + keepInCookieName
            const cookie = infraLerCookie(cookieName)

            if (cookie) {
                let columns = JSON.parse(unescape(cookie))

                if (!isMarked) {
                    columns = columns.filter(column => column !== columnName)
                } else if (!columns.includes(columnName)) {
                    columns.push(columnName)
                }

                infraCriarCookie(cookieName, JSON.stringify(columns))
            }
        }
    }

    function initKeepInCookie() {
        if (infraCookiesHabilitados()) {
            const cookieName = tableId + keepInCookieName
            const cookie = infraLerCookie(cookieName)

            if (!cookie) {
                const columns = allColumns.filter(column => column.show).map(column => column.data)
                infraCriarCookie(cookieName, JSON.stringify(columns))
            }
        }

    }

    function updateColumns(columns) {
        const newColumns = allColumns.filter(
            (column) => column['data'] && columns.filter((value) => value === column['data']).length > 0,
        );
        initOpts.columns = newColumns;
        dt.table().destroy(false);
        tableEl.html('');
        DataTableHelper.build(initOpts);
    }

    function getResponsive(isResponsivoComDetalhe) {
        let responsive = {
            details: {
                display: $.fn.dataTable.Responsive.display.childRowImmediate,
                type: 'none',
                target: '',
            },
        }
        if (isResponsivoComDetalhe) {
            responsive = {
                details: {
                    type: 'column',
                },
            }
        }
        return responsive;
    }

    function configColunaAcoes(columns, isResponsivoComDetalhe = false) {
        let colAcoes = {
            "data": "col_acoes",
            "title": 'Ações',
            "orderable": false,
            "width": "41px",
            "className": 'acoes-table not-export-col',
            "render": function(data, type, row) {
                const acoes = opts.colunaAcoes(data, type, row);
                return renderActions(acoes);
            },
        };
        if (isResponsivoComDetalhe) {
            colAcoes.responsivePriority = 1000;
        }
        columns.push(colAcoes);
        return columns;
    }

    function configColunaSelecionavel(columns, name = '') {
        columns.unshift({
            'data': 'col_checkbox',
            'title': '<input type="checkbox" name="chkTodos">',
            'orderable': false,
            'className': 'text-center not-export-col',
            'width': '15px',
            'render': function(data, type, row, meta) {
                if ((name !== '') && (name !== 'chkRow')) {
                    return '<input type=checkbox class="chkRowDataTable" id="' + name + '_' + row.DT_RowId + '" name="'
                        + name + '[]" value="' + row.DT_RowId + '">';
                } else {
                    return '<input type=checkbox class="chkRowDataTable" name="chkRow_' + row.DT_RowId + '">';
                }
            },
        });
        return columns;
    }

    function configColunaExpandirDetalhes(columns) {
        columns.unshift({
            'data': 'col_detalhes',
            'title': '',
            'orderable': false,
            'className': 'dtr-control text-center not-export-col',
            'width': '15px',
        });
        return columns;
    }

    function getCheckedData(id) {
        return $('#' + id + ' [class="chkRowDataTable"]:checked').map(function() {
            return $('#' + id).dataTable().api().row(this.parentElement.parentElement).data();
        }).toArray();
    }

    $.fn.dataTable.Api.register('rows().getSelected()', function() {
        var id = this.table().node().id;
        return getCheckedData(id);
    });

    $.fn.dataTable.Api.register(
        'formSearch()',
        /**
         *
         * @param data Object
         */
        function(data) {
            const requestParams = new URLSearchParams(data)
            this.search(requestParams).draw()
        },
    )

    $.fn.dataTable.Api.register('rows().getSelectedData()', function(colOrColsToFilter) {
        var id = this.table().node().id;
        var rows = getCheckedData(id);

        return rows.map(function(row) {
            if (Array.isArray(colOrColsToFilter)) {
                return _.pick(row, colOrColsToFilter);
            } else {
                if (!row.hasOwnProperty(colOrColsToFilter)) {
                    throw "Chave '" + colOrColsToFilter + "' não encontrado na linha selecionada";
                }

                return row[colOrColsToFilter]
            }
        })
    });

    function toggleAcoes(rows) {
        let acoesWrapper = $(`#${opts.tableId}-acoes-wrapper`);
        let botoes = $(`#${opts.tableId}_wrapper .btn-acoes-wrapper`);
        if (rows.length) {
            acoesWrapper.addClass('d-flex');
            botoes.addClass('d-flex');
        } else {
            acoesWrapper.removeClass('d-flex');
            botoes.removeClass('d-flex');
        }
    }
}

const getInfoTopId = (tableId) => tableId + '_info-badge'

function onInitCompleteAddRowCount(tableId, opts, settings, json) {
    const dt = $(`#${tableId}`).DataTable()
    const infoTopId = getInfoTopId(tableId)
    const tableTitle = !opts.tableTitle ? '' : `
              <h2 class="d-flex float-left align-items-center">
                  <span>${opts.tableTitle}</span>
                  <span 
                      id="${infoTopId}"
                      data-toggle="tooltip"
                      tabindex="0"
                      class="ml-1 mr-2 badge badge-pill text-secondary px-1 font-weight-normal">
                  </span>
              </h2>
            `

    $(dt.table().node())
        .parents('.dataTables_wrapper')
        .find('.container-acoes-bloco')
        .prepend(tableTitle)

    $(`#${infoTopId}`).tooltip({
        title: () => document.getElementById(`${tableId}_info`)?.innerText,
    })
}

function updateTitleCountBadge(tableId, searched, deferLoading, settings) {
    const infoTopId = getInfoTopId(tableId);
    const el = document.getElementById(infoTopId)

    if (el) {
        if (!searched && deferLoading) {
            el.style.display = 'none';
        } else {
            el.style.display = '';
        }
        el.innerHTML = `(${settings.fnRecordsDisplay()})`
    }
}

export default {
    createAcaoConsultar: createAcaoConsultar,
    createAcaoAlterar: createAcaoAlterar,
    createAcaoDesativar: createAcaoDesativar,
    createAcao: createAcao,
    build: build,
    buildClientSideWithServerData: buildClientSideWithServerData,
    ACTION_TYPES: ACTION_TYPES,
}